<div style="min-width: 1200px;">
  <router-outlet></router-outlet>
</div>
<div *ngIf="error$ | async"></div>
<div *ngIf="info$ | async"></div>
